import React from 'react';

const PlateNumber = ({ cellData }) => {
  return <div>{cellData.toUpperCase() || ''}</div>;
};

export default PlateNumber;
